import {createRouter, createWebHistory} from 'vue-router'

import * as Admin from '@/views/admin'
import * as Public from '@/views/public'

import {accountService} from '@/services/account.service'
import NotFound from '@/views/NotFound.vue'
import LoginPage from '@/views/authentification/LoginPage.vue'


const routes = [
    {
        path: '/public',
        name: 'public',
        component: Public.PublicLayout,
        meta: { requiresAuth: false },
        children: [
            { path: '/', name: 'accueil', component: Public.AccueilPage, meta: { requiresAuth: false } },
            { path: 'boisDAllumage', name: 'boisDAllumage', component: Public.BoisDAllumagePage, meta: { requiresAuth: false } },
            { path: 'boisDeChauffage', name: 'boisDeChauffage', component: Public.BoisDeChauffagePage, meta: { requiresAuth: false } },
            { path: 'contact', name: 'contact', component: Public.ContactPage, meta: { requiresAuth: false } },
            { path: 'grume', name: 'grume', component: Public.GrumePage, meta: { requiresAuth: false } },
        ]
    },
    {
        path: '/admin',
        name: 'admin',
        component: Admin.AdminLayout,
        meta: { requiresAuth: true },
        children: [
            { path: 'dashboard', component: Admin.DashBoard, meta: { requiresAuth: true } },

            { path: 'stock/index', component: Admin.StockIndex, props: true, meta: { requiresAuth: true } },
            { path: 'stock/edit/:id(\\d+)?', name: 'stockEdit', component: Admin.StockEdit, props: true, meta: { requiresAuth: true } },
            { path: 'stock/transfet', component: Admin.StockTransfert, meta: { requiresAuth: true } },

            { path: 'categorie/index', component: Admin.CategorieIndex, meta: { requiresAuth: true } },
            { path: 'categorie/edit/:id(\\d+)?', name: 'categorieEdit', component: Admin.CategorieEdit, props: true, meta: { requiresAuth: true } },

            { path: 'zoneStockage/index', component: Admin.ZoneStockageIndex, meta: { requiresAuth: true } },
            { path: 'zoneStockage/edit/:id(\\d+)?', name: 'zoneStockageEdit', component: Admin.ZoneStockageEdit, props: true, meta: { requiresAuth: true } },

            { path: 'fournisseur/index', component: Admin.FournisseurIndex, meta: { requiresAuth: true } },
            { path: 'fournisseur/edit/:id(\\d+)?', name: 'fournisseurEdit', component: Admin.FournisseurEdit, props: true, meta: { requiresAuth: true } },

            { path: 'mouvementStock/edit/:id(\\d+)?', name: 'mouvementStockEdit', component: Admin.MouvementStockEdit, props: true, meta: { requiresAuth: true } },

            { path: 'client/index', name: 'clientIndex', component: Admin.ClientIndex, props: true, meta: { requiresAuth: true } },
            { path: 'client/info/:id(\\d+)?', name: 'clientInfo', component: Admin.ClientInfo, props: true, meta: { requiresAuth: true } },
            { path: 'client/edit/:id(\\d+)?', name: 'clientEdit', component: Admin.ClientEdit, props: true, meta: { requiresAuth: true } },


            { path: 'commande/edit/:id(\\d+)?', name: 'commandeEdit', component: Admin.CommandeEdit, props: true, meta: { requiresAuth: true } },
            { path: 'commande/info/:id(\\d+)?', name: 'commandeInfo', component: Admin.CommandeInfo, props: true, meta: { requiresAuth: true } },

            { path: 'planning/index', name: 'planningIndex', component: Admin.PlanningIndex, props: true, meta: { requiresAuth: true } },
            { path: 'livraison/create:id(\\d+)?', name: 'livraisonCreate', component: Admin.LivraisonCreate, props: true, meta: { requiresAuth: true } },
            { path: 'livraison/addCommande:id(\\d+)?', name: 'livraisonAddCommande', component: Admin.LivraisonAddCommande, props: true, meta: { requiresAuth: true } }
        ]
    },
    {
        path: '/login', name: 'Login', component: LoginPage, meta: { requiresAuth: false }
    },
    {
        path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, meta: { requiresAuth: false }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to) => {
    const requiresAuth = to.matched.some(r => r.meta.requiresAuth);

    if (!requiresAuth) return true;

    if (accountService.isCachedLoggedIn()) return true;;

    if (await accountService.isLogged()) return true;;

    return { name: 'Login', query: { redirect: to.fullPath } };
});

export default router